import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const RewardsSelectCustomGiftCard = ({
  onBack = () => {},
  onNext = () => {},
  canGoNext,
  inputs = [],
}) => {
  const { t } = useTranslation(['rewards-loyalty', 'common'])
  return (
    <div>
      <div className="rewards-modal-content rewards-base-view select-custom-gift">
        <div className="rewards-modal-input-row">{inputs.first && inputs.first.render()}</div>
      </div>
      <div className="rewards-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.back')}
        </button>
        <button className="button button-primary" disabled={!canGoNext} onClick={onNext}>
          {t('rewards-loyalty:activityForm.nextButton')}
        </button>
      </div>
    </div>
  )
}

RewardsSelectCustomGiftCard.propTypes = {
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  canGoNext: PropTypes.bool,
  inputs: PropTypes.object,
}

export default RewardsSelectCustomGiftCard
